'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of germs
 */ const Germs = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M104 52C104 80.7188 80.7188 104 52 104C23.2812 104 -1.14594e-05 80.7188 -1.14594e-05 52C-1.14594e-05 23.2812 23.2812 5.33663e-06 52 5.33663e-06C80.7188 5.33663e-06 104 23.2812 104 52Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M56.6631 80.4812C39.1973 80.4812 24.9922 64.8622 24.9922 45.654C24.9922 40.0362 29.1318 35.4824 34.2355 35.4824C39.3391 35.4824 43.4787 40.0362 43.4787 45.654C43.4787 53.6408 49.3904 60.1523 56.6631 60.1523C61.7668 60.1523 65.9064 64.7061 65.9064 70.3239C65.9064 75.9416 61.7668 80.4812 56.6631 80.4812Z",
                stroke: "#FAFFFC",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M22.4219 38.7441L26.1779 40.6305",
                stroke: "#FAFFFC",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M33 31.9141L33.2835 35.5449",
                stroke: "#FAFFFC",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M45.9762 39.1016L42.2344 40.5482",
                stroke: "#FAFFFC",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M48.8964 50.1641L44.8711 52.1071",
                stroke: "#FAFFFC",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M56.6085 56.7402L55.418 60.0874",
                stroke: "#FAFFFC",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M68.7846 63.4453L64.6602 65.1898",
                stroke: "#FAFFFC",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M69.237 76.7804L64.9141 74.9082",
                stroke: "#FAFFFC",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M60.4704 83.687L59.2656 80.0703",
                stroke: "#FAFFFC",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M49.3281 83.9975L50.3486 79.7852",
                stroke: "#FAFFFC",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M38.1797 79.5765L40.3766 75.7188",
                stroke: "#FAFFFC",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M30.0859 72.1694L33.4592 69.4746",
                stroke: "#FAFFFC",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M24.4844 63.3847L28.3112 61.5977",
                stroke: "#FAFFFC",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M21.6055 52.3216L25.489 51.8535",
                stroke: "#FAFFFC",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M57.1133 27.8184L60.4724 30.7259",
                stroke: "#86B09B",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M52.8828 39.8296L57.5895 38.7656",
                stroke: "#86B09B",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M69.7275 51.8535L69.2031 48.4922",
                stroke: "#86B09B",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M81.5836 43.8117L78.3945 42.209",
                stroke: "#86B09B",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M78.197 26.3066L75.3906 29.3985",
                stroke: "#86B09B",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M67.2266 23.1836L67.4108 26.7293",
                stroke: "#86B09B",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M82.4166 34.6719L78.7031 35.1115",
                stroke: "#86B09B",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M76.6247 49.3684L74.8672 46.5176",
                stroke: "#86B09B",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M59.3867 49.8923L61.8104 46.4316",
                stroke: "#86B09B",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M53.5382 74.3008C55.8871 74.3008 57.7912 72.3954 57.7912 70.0449C57.7912 67.6945 55.8871 65.7891 53.5382 65.7891C51.1893 65.7891 49.2852 67.6945 49.2852 70.0449C49.2852 72.3954 51.1893 74.3008 53.5382 74.3008Z",
                stroke: "#FAFFFC",
                strokeWidth: "1.38757",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "68.4077",
                cy: "37.6733",
                r: "10.8686",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("ellipse", {
                cx: "34.2571",
                cy: "47.8295",
                rx: "9.34699",
                ry: "12.3177",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("ellipse", {
                cx: "56.1321",
                cy: "70.2846",
                rx: "9.34699",
                ry: "10.144",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M44.8317 52.6807L43.455 48.623L26.5 52.0285L26.8623 57.5353L28.8186 62.3175L31.4271 67.0272L35.847 71.9543L39.4699 75.07L43.455 77.461L48.3097 79.3449L52.7295 80.0695L54.541 60.1438L50.0486 58.4048L47.0054 55.6514L44.8317 52.6807Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "53.6006",
                cy: "69.8564",
                r: "4.05761",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "53.75",
                cy: "70.291",
                r: "4.5",
                fill: theme.ds5.asset[assetColor]["500"]
            })
        ]
    });
};

exports.Germs = Germs;
//# sourceMappingURL=Germs.cjs.map
